import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var FormContext = /*#__PURE__*/React.createContext(null);
var FormProvider = function FormProvider(props) {
  var context = React.useMemo(function () {
    return {
      clearFormControlRef: props.clearFormControlRef,
      defaultValuesRef: props.defaultValuesRef,
      disableAll: props.disableAll,
      formId: props.formId,
      inlineAll: props.inlineAll,
      onChange: props.onChange,
      setFormControlRef: props.setFormControlRef
    };
  }, [props.disableAll, props.formId, props.inlineAll, props.onChange]);
  return /*#__PURE__*/jsx(FormContext.Provider, {
    value: context,
    children: props.children
  });
};
FormProvider.displayName = "FormProvider";
function useFormContext() {
  return React.useContext(FormContext);
}

export { FormProvider, useFormContext };
